import React from 'react';
import WarnContent from '../../WarnContent';
import styles from './index.less';

const LockedWarn = () => (
  <div className={styles['warn-content']}>
    <WarnContent
      title="密码错误"
      text="当天密码连续10次错误，锁定不可查看，可联系超级管理员解除或者重置密码"
    />
  </div>
);

export default LockedWarn;
